<template>
  <v-app>
    <div v-if="!loading">
      <core-toolbar v-if="$route.name != 'Gis' && $route.name != 'Ingresar'" />
      <core-drawer v-if="$route.name != 'Gis' && $route.name != 'Ingresar'" />
      <core-view />
    </div>
    <div v-if="loading">
    </div>
  <div v-if="!loading && fail">
    <core-errors :errors="errors" />
  </div>
  </v-app>
</template>
<script>
	export default {
		created(){
			this.verifyCookies();
		},
		mounted() {
			this.getPermiss();
			this.getRoutes();
		},
		data(){
			return {
				loading: false,
				fail: false,
				errors: [],
				webApi: process.env.VUE_APP_URL,
			}
		},
		methods: {
			getPermiss(){
				 this.$store.state.logged = false
			},
			getRoutes(){
				//axios.get();
			},
			verifyCookies(){
				axios.interceptors.response.use((response) => response, (error) => {
				//console.log(error.response.headers);
					if(error.response.data.message == 'Unauthenticated.' && this.$route.name != 'Gis'){
					    window.location.replace("/login")
					    $cookies.remove('Session_Cookie')
					}
				});
				if($cookies.isKey('Session_Cookie')){
					this.$nextTick(() => {
				    axios({
				      url:this.webApi + 'api/user/get?uid=1',
				      method: 'get',
				    }).then((res) => {
				      this.$store.commit('api/setApiToken', $cookies.get('Session_Cookie'))
				      this.$store.commit('api/setUser', res.data)
				      this.$store.commit('api/setLogged', true)
				      this.$store.commit('api/setMenu', res.data.menu)
				    }).catch((error) => {
				    	if(error.response.data.message == 'Server Error'){
				    		this.verifyCookies();
				    	}
				    	console.log(error)
				    })
					})
			  }else{
			    this.$store.commit('api/setApiToken', '')
			    this.$store.commit('api/setUser', {})
			    this.$store.commit('api/setLogged', false)
		      this.$store.commit('api/setMenu', {})
			  }
			}
		}
	}
</script>


